import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, Grid2, Input, Paper, Stack, ToggleButton, ToggleButtonGroup, Typography, useTheme } from "@mui/material";
import axios from 'axios';
import React, { useState } from "react";
import { hiddenInputSx } from '../../common/styleUtil';
import StudentForm from '../../student/student.form';
import { studentApi } from '../../student/student.queries';

export default function StudentsStep(props) {
	const useSave = studentApi.useSave();
	const preUpload = studentApi.usePreUpload();

	const theme = useTheme();
	const [students, setStudents] = useState(props.students);
	const [numStudents, setNumStudents] = useState(props.students?.length || 0);
	const [avatarGroups, setAvatarGroups] = useState([]);

	const generateUniqueRandomNumbers = (min, max, count) => {
		const numbers = new Set();
		while (numbers.size < count) {
			const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
			numbers.add(randomNumber);
		}
		return Array.from(numbers);
	}

	const randomizeAvatarGroups = (num) => {
		const avatarGroups = [];
		for (let i = 0; i < num; i++) {
			avatarGroups.push(generateUniqueRandomNumbers(0, 8, 3));
		}
		setAvatarGroups(avatarGroups);
	}

	const toggleStudentCount = (count) => {
		while (students?.length < count) {
			students.push({});
		}
		setStudents([...students]);
		setNumStudents(count);
		randomizeAvatarGroups(count);
	}

	const setStudent = (i, student) => {
		students[i] = student;
		setStudents([...students]);
	};

	const setStudentAvatar = (i, url) => {
		students[i].profilePicture = url;
		setStudent(i, students[i]);
	}

	const saveStudents = async () => {
		const result = await useSave.mutateAsync(students);
		props?.onNext?.();
	};

	const uploadFile = async (i, file) => {
		const student = students[i];
		const id = student.id;
		const data = {
			fileName: file.name,
			fileType: file.type,
		};
		let result = await preUpload.mutateAsync({ id, data });

		const url = result.url;
		const { origin, pathname } = new URL(url);

		result = await axios.put(url, file, {
			headers: {
				'Content-Type': file.type,
			},
		});

		setStudentAvatar(i, origin + pathname);
	};

	if (numStudents > avatarGroups?.length) {
		randomizeAvatarGroups(numStudents);
	}

	return (
		<React.Fragment>
			<Paper sx={props.sx}>
				<Typography variant="h3">How many students do you teach?</Typography>
				<Stack direction="column" alignItems="center">
					<ToggleButtonGroup color="primary" value={numStudents} exclusive onChange={(e, value) => { toggleStudentCount(value) }}>
						{Array.from({ length: 8 }).map((nil, i) => (
							<ToggleButton sx={{ height: 40, p: 4 }} value={i + 1} key={'numStudents' + i}>{i + 1}</ToggleButton>
						))}
					</ToggleButtonGroup>
				</Stack>
			</Paper>

			{Array.from({ length: numStudents }).map((nil, i) => (
				<Paper sx={props.sx} key={'student' + i}>
					<Typography variant="h3">Student #{i + 1}</Typography>
					<Grid2 container spacing={4}>
						<Grid2 size={{ xs: 12, sm: 6, md: 8 }}>
							<StudentForm student={students[i]} onChange={student => setStudent(i, student)} />
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
							<Grid2 container spacing={2}>
								{avatarGroups[i]?.map(j => (
									<Grid2 size={6} key={'avatarGroup' + j}>
										<Button variant="contained" sx={students[i].profilePicture == `/avatars/${j}.png` ? { outline: '2px solid ' + theme.palette.action.disabled } : {}} onClick={() => setStudentAvatar(i, `/avatars/${j}.png`)}>
											<img src={`/avatars/${j}.png`} width="100%" />
										</Button>
									</Grid2>
								))}

								<Grid2 size={6}>
									<Button component="label" variant="contained" sx={[{ width: '100%', height: '100%' }, students[i].profilePicture?.indexOf('/') > 0 ? { outline: '2px solid ' + theme.palette.action.disabled } : {}]} role={undefined}>
										{students[i].profilePicture?.indexOf('/') > 0 ?
											<img src={students[i].profilePicture} width="100%" />
											:
											<CloudUploadIcon sx={{ fontSize: 50, color: '#aaaaaa' }} />
										}
										<Input sx={hiddenInputSx} type="file" onChange={(event) => { uploadFile(i, event.target.files[0]) }} />
									</Button>
								</Grid2>
							</Grid2>
						</Grid2>
					</Grid2>
				</Paper>
			))}

			<Stack justifyContent="space-between">
				<Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={() => props?.onPrevious?.()}>Previous</Button>
				<Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={() => saveStudents()}>Next</Button>
			</Stack>
		</React.Fragment>
	);
}